import { TailSpin } from "react-loader-spinner";

import * as S from "../FirstAccess.styles";

export type CheckoutRegistrationLoaderPhase = "waiting" | "sending";

interface CheckoutRegistrationLoaderProps {
  phase: CheckoutRegistrationLoaderPhase;
  progress: number;
  statusMessage: string;
  smoothComplete: boolean;
  email?: string;
}

function getTitle(phase: CheckoutRegistrationLoaderPhase): string {
  if (phase === "sending") {
    return "Enviando código...";
  }

  return "Preparando seu acesso...";
}

export default function CheckoutRegistrationLoader({
  phase,
  progress,
  statusMessage,
  smoothComplete,
  email,
}: CheckoutRegistrationLoaderProps) {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <>
      <S.Header>
        <img src="/media/logos/logo.svg" alt="Logo Jusfy" />
      </S.Header>

      <S.Wrapper>
        <S.Section>
          <S.Container>
            <S.Div aria-live="polite" aria-atomic="true">
              <S.Title>{getTitle(phase)}</S.Title>
              <S.LoadingStatusMessage key={statusMessage}>
                {statusMessage}
              </S.LoadingStatusMessage>
              {email && phase === "sending" ? (
                <S.Subtitle style={{ marginBottom: 0 }}>
                  Enviando para {email}
                </S.Subtitle>
              ) : null}
            </S.Div>

            <S.ProgressWrapper>
              <S.ProgressTrack
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={Math.round(clampedProgress)}
                aria-label="Progresso da preparação do cadastro"
              >
                <S.ProgressFill
                  $progress={clampedProgress}
                  $smooth={smoothComplete}
                />
              </S.ProgressTrack>
              <S.ProgressLabel>
                {Math.round(clampedProgress)}%
              </S.ProgressLabel>
            </S.ProgressWrapper>

            {phase === "sending" ? (
              <TailSpin
                visible
                height="28"
                width="28"
                color="#41C78F"
                ariaLabel="loading"
              />
            ) : null}
          </S.Container>
        </S.Section>
        <S.Banner src="/media/flat/mail-inbox.svg" alt="" />
      </S.Wrapper>
    </>
  );
}
